import { NgModule } from '@angular/core';

import { SignalrNotificationService } from './services/signalr-notification.service';
@NgModule({
  imports: [
  ],
  declarations: [
  ],
  exports: [
  ],
  providers: [
    SignalrNotificationService
  ]
})
export class SignalrNotificationModule { }
